import React from 'react';
import styles from "./OfferInfoNotification.scss";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { FOREVER_FELINE_CHEM } from 'constants/ProviderEnrollment';

const ForeverFelineChemNotification = ({ userProfile }) => {
  const history = useHistory();

  const navigateToEnrollment = () => {
    if (window.location.pathname.includes('admin')) {
      history.push(`/admin/provider/1/location/${userProfile.nodeId}/offer-enrollment`);
    } else {
      history.push(`/provider/location/${userProfile.nodeId}/offer-enrollment`);
    }
  };

  return (
    <div className={styles.container}>
      <p>
        {FOREVER_FELINE_CHEM.description} {" "}
        <a
          href={FOREVER_FELINE_CHEM.pdf}
          target="_blank"
          rel="noopener noreferrer"
        >
          detailer and terms and conditions.
        </a>
      </p>
      <div className={styles.buttonContainer}>
        <button
          onClick={navigateToEnrollment}
          className={styles.viewButton}
        >
          Go to Enrollment Page
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.user.userProfile
});

export default connect(mapStateToProps)(ForeverFelineChemNotification);